module.exports = __webpack_public_path__ + "RMR FSA Enrollment Guide.pdf";